/* axios setting : 서버와 통신하는 HTTP Request 라이브러리 설정 파일 */

import axios from "axios";
import store from "../store";
import router from "../router";
import { SERVER_URL } from "../config/const";

// * axios instance 생성
const axiosInstance = axios.create({
    // * default -> "development"
    // * npm run serve 실행 시 NODE_ENV 기본값 "development" / npm run build 실행 시 NODE_ENV 기본값 "production"
    baseURL: process.env.NODE_ENV === "development" ? SERVER_URL.DEVELOPMENT : SERVER_URL.PRODUCTION
});


// TODO 토큰의 만료 시간을 확인하는 함수 : 해당 함수를 통해서 토큰 시간 만료 시, 서버로 가는 경우(accessToken 유효 검증)를 줄여서 재발급 받을 수 있지만 현재는 사용 X
const isTokenExpire = (token) => {
    // token의 두 번째 부분, payload 부분을 가져와서 base64로 디코딩하고 JSON 형태로 접근하기 위해 JSON.parse
    // atob 인코딩 문자열 디코딩
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp < Date.now().getTime() / 1000;
};


// ? axios request전에 항상 실행되는 GOBAL REQUEST HANDLER
axiosInstance.interceptors.request.use(
    config => {
        config.headers.authorization = `Bearer ${store.state.userInfo.accessToken}`;
        return config;
    },
    error => Promise.reject(error)
);


// ? axios response을 받자마자 항상 사용되는 GLOBAL ERROR HANDLER
axiosInstance.interceptors.response.use(
    response => response,
    async (error) => {
        const originRequest = error.config; // 기존 요청
        const errorResponse = error.response.data;  // 에러 변수
        
        // * accessToken 만료 시, refreshToken으로 token 재발급 받는 구문
        if (errorResponse.status === 401 && errorResponse.message === "EXPIRE_TOKEN" && !originRequest._retry) {

            /* 
             * 재시도 로직을 구현할 때, 무한 루프에 빠지는 것을 방지하는 역할
             * 처음에는 originRequest._retry = undefined일 경우 실행되고, 로직 실행 시 true로 변경되면서 두 번 이상 재시도가 발생하지 않음.
             * 1. accessToken에 올바르지 않은 값이 들어가서 계속 서버에 재발급 요청할 경우 무한 루프에 빠짐.
             * 2. accessToken을 재발급 할 refreshToken이 유효하지 않은 상태에서 서버가 계속 401 에러를 반환하고, 클라이언트가 재시도하면 무한 루프에 빠짐.
            */
            originRequest._retry = true;

            // * refreshToken으로 토큰 재발급 (해당 axios 구문에서 에러 발생 시, interceptors.response에 걸림)
            const token = await axiosInstance.post("/token", { refresh_token: store.state.userInfo.refreshToken });

            // * 새로운 token vuex에 저장
            store.commit("SET_TOKEN", {
                accessToken: token.data.result.accessToken,
                refreshToken: token.data.result.refreshToken,
            });

            // * 기존에 시도하려 했던 요청 재시도
            return axiosInstance(originRequest);

        } else if (errorResponse.status === 403) {
            /* 
             * [FORBIDDEN] status : 403 -> USERINFO 삭제 후, 로그인 페이지로 이동
             * 1. accessToken 복호화 시, paylaod user_key로 생성된 유저가 존재하지 않는 경우
             * 2. accessToken 복호화 시, paylaod user_key로 생성된 유저가 삭제되거나, 탈퇴한 경우
             * 3. refreshToken으로 accessToken 재발급 시, refreshToken의 복호화에 문제가 있을 경우
             * 4. token DB에 refreshToken 정보가 없거나, 클라이언트에서 넘어온 token과 DB에 저장된 token이 일치하지 않는 경우 
             */

            store.commit("DEL_USERINFO");
            router.push("/");
        } else {
            // 그 외 에러
            return Promise.reject(error);
        }
    }
);

export default axiosInstance;